import { IntegrationApiFeaturesOutagesContractsDataOutage } from "@alliander-fe/api";
import { isOutageCause } from "src/utils";
import { Props } from "../index";

/**
 * We handle multiple scenarios that require different texts to be displayed. Scenarios are determined by the cause and status of the outage.
 * @param texts The props that contain the texts
 * @param outage The outage data (probably from the API)
 * @param isSpecific Whether this is a specific outage or a general outage
 * @returns The correct set of texts based on cause and status of the outage.
 */

export function getOutageStrings(
  texts: Props,
  outage: IntegrationApiFeaturesOutagesContractsDataOutage,
  isSpecific: boolean
) {
  const isMaintenance = !isOutageCause(outage?.cause);
  const hasOutage = Boolean(!isMaintenance && outage.outageNumber);
  const noOutage = Boolean(!outage.outageNumber);
  const isResolved = outage.status === 'opgelost';

  switch (true) {
    case noOutage && isSpecific:
      return {
        title: texts.specificNoOutageHeroTitle,
        detailTitle: '',
        modalTitle: '',
      };
    case isSpecific && hasOutage:
      return {
        title: texts.specificActiveOutageHeroTitle,
        detailTitle: texts.specificActiveOutageDetailTitle,
        modalTitle: texts.specificActiveOutageModalTitle,
      };
    case isSpecific && isMaintenance:
      return {
        title: texts.specificActiveMaintenanceHeroTitle,
        detailTitle: texts.specificActiveMaintenanceDetailTitle,
        modalTitle: texts.specificActiveMaintenanceModalTitle,
      };

    // This is where isSpecific is false, and thus is a general outage
    case isResolved && isMaintenance:
      return {
        title: texts.generalResolvedMaintenanceHeroTitle,
        detailTitle: texts.generalResolvedMaintenanceDetailTitle,
        modalTitle: texts.generalResolvedMaintenanceModalTitle,
      };
    case isResolved:
      return {
        title: texts.generalResolvedOutageHeroTitle,
        detailTitle: texts.generalResolvedOutageDetailTitle,
        modalTitle: texts.generalResolvedOutageModalTitle,
      };
    case isMaintenance:
      return {
        title: texts.generalActiveMaintenanceHeroTitle,
        detailTitle: texts.generalActiveMaintenanceDetailTitle,
        modalTitle: texts.generalActiveMaintenanceModalTitle,
      };
    default:
      return {
        title: texts.generalActiveOutageHeroTitle,
        detailTitle: texts.generalActiveOutageDetailTitle,
        modalTitle: texts.generalActiveOutageModalTitle,
      };
  }
}
